module.exports = __webpack_public_path__ + "2f22b69bfff85b5e86a417031a1c8a6b.jpg";